import {Controller} from "@hotwired/stimulus"
import {iframeResize} from 'iframe-resizer'

export class IFrameController extends Controller {
    static targets = ["loading", "content"];

    connect() {
        iframeResize({
            onMessage: (data) => {
                if (data.message.pageTitle !== undefined && data.message.pageTitle !== null) {
                    document.title = data.message.pageTitle
                }
                history.replaceState(null, null, data.message.pageLocation.replace('/c/', '/'))
            },
        }, this.contentTarget);
    }
}